import { Reveal } from "../components/Reveal";
import { useSiteImages } from "../context/SiteImagesContext";
import { API } from "../lib/api";

const CLOSEUPS = [
  { key: "gallery:amarillo", label: "Amarillo", hex: "#F2C94C" },
  { key: "gallery:rojo", label: "Rojo", hex: "#E56A6A" },
  { key: "gallery:rosa", label: "Rosa fucsia", hex: "#D94F8E" },
];

export default function Colores() {
  const { resolve } = useSiteImages();

  return (
    <section
      id="colores"
      data-testid="colores-section"
      className="py-24 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">05</span> &nbsp;/&nbsp; Colores
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Elige el color que <br /> mejor te acompañe.
          </h2>
          <p className="text-[#4A554E] mt-5 max-w-xl leading-relaxed font-light">
            Cada carpeta tiene alma propia. Elige entre nuestros colores para tu tamaño
            40 o 60 fundas. Para 80 fundas, disponible en blanco.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-3 gap-5">
          {CLOSEUPS.map((c, i) => (
            <Reveal
              key={c.key}
              delay={i * 0.08}
              className="rounded-[2rem] overflow-hidden bg-white border border-[#EBEBEB] group"
            >
              <figure className="relative">
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={resolve(c.key, `${API}/images/${c.key}`)}
                    alt={`VITAE en color ${c.label.toLowerCase()}`}
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-1000"
                    data-testid={`closeup-${c.label.toLowerCase()}`}
                  />
                </div>
                <figcaption className="p-5 flex items-center gap-3 bg-white">
                  <span className="font-display text-lg text-[#2D3732]">{c.label}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
